import React from 'react';
import styles from './DateBadge.module.scss';

const PALETTE = ['blue', 'success', 'purple', 'orange'];

export const DateBadgeComponent = ({ date, colorIndex = 0 }) => {
  const color =
    PALETTE[((colorIndex % PALETTE.length) + PALETTE.length) % PALETTE.length];

  return (
    <div className={styles.dateBadge} data-color={color}>
      <span className={styles.dayAbbrev}>
        {date.format('ddd').toUpperCase()}
      </span>
      <span className={styles.dayNumber}>{date.format('D')}</span>
      <span className={styles.monthYear}>
        {date.format('MMM YYYY').toUpperCase()}
      </span>
    </div>
  );
};

DateBadgeComponent.displayName = 'DateBadge';
